import { Box } from "@mui/material";
import { DotLegalMultiSelect, DotLegalSelect } from "@dotlegal/dotlegal-ui-components";
import { useTranslation } from "@localization/useTranslation";
import { usePlanContext } from "../../auth/planProvider/PlanProvider";
import { useUserContext } from "../../auth/userContextProvider/UserContextProvider";
import { PurpleLockIcon } from "@common/icons";
import TagsMultiSelect from "@common/components/tagsMultiSelect/TagsMultiSelect";
import { TagRelationType } from "@common/components/tagsMultiSelect/TagsMultiSelect.types";
import PlanInputFieldWrapper from "../../plan/planInputFieldWrapper/PlanInputFieldWrapper";
import ActivityFormBox from "./ActivityFormBox";
import { ActivityCategorisationSectionProps, useActivityCategorisationSection } from "./ActivityCategorisationSection.hooks";
import { useActivityFormStyles } from "./ActivityForm.styles";

function ActivityCategorisationSection(props: ActivityCategorisationSectionProps) {
    const { translateString } = useTranslation();
    const { platformFeatures } = usePlanContext();
    const { permissions } = useUserContext();
    const styles = useActivityFormStyles();
    const {
        generalTypeOptions,
        complianceAreas,
        complianceAreasLoading,
        businessAreas,
        businessAreasLoading,
        onGeneralTypeChange,
        onComplianceAreasChange,
        onTagsChange,
        onBusinessAreasChange,
    } = useActivityCategorisationSection(props);

    return (
        <ActivityFormBox title={translateString("activityFormCategorisation")} startsWithFieldLabel>
            <Box sx={styles.twoColumns}>
                {!props.model.contractId && (
                    <DotLegalSelect
                        label={translateString("type")}
                        options={generalTypeOptions}
                        selectedItem={props.model.generalType?.toString() ?? ""}
                        onChange={onGeneralTypeChange}
                        placeholder={""}
                        noOptionsLabel={translateString("noOptions")}
                        disabled={props.readOnly}
                        useFixedLabel
                    />
                )}

                {!props.model.isProcessingActivityValidation && (
                    <>
                        <PlanInputFieldWrapper hasAccess={platformFeatures.annualWheelComplianceArea} hoverText={translateString("upgradePrivacyPlanToday")}>
                            <DotLegalMultiSelect
                                label={translateString("areas")}
                                toolTipText={translateString("complianceAreaToolTip")}
                                options={complianceAreas}
                                isLoading={complianceAreasLoading}
                                chosenOptions={props.model.areas}
                                onChange={onComplianceAreasChange}
                                placeholder={""}
                                noOptionsLabel={translateString("noOptions")}
                                disabled={props.readOnly || !platformFeatures.annualWheelComplianceArea}
                                icon={!platformFeatures.annualWheelComplianceArea ? PurpleLockIcon : undefined}
                                useFixedLabel
                            />
                        </PlanInputFieldWrapper>

                        <DotLegalMultiSelect
                            label={translateString("businessAreas")}
                            options={businessAreas}
                            isLoading={businessAreasLoading}
                            chosenOptions={props.model.businessAreas}
                            onChange={onBusinessAreasChange}
                            placeholder={""}
                            noOptionsLabel={translateString("noOptions")}
                            disabled={props.readOnly}
                            useFixedLabel
                        />
                    </>
                )}

                {permissions.canAccessTags && (
                    <TagsMultiSelect
                        isLoading={false}
                        entityType={TagRelationType.AnnualWheelActivity}
                        selectedTags={props.model.tags}
                        onChange={onTagsChange}
                        disabled={props.readOnly}
                        useFixedLabel
                    />
                )}
            </Box>
        </ActivityFormBox>
    );
}

export default ActivityCategorisationSection;
